import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'src/libs/axios';
import { useAuth } from 'src/libs/rainbow';
import { QueryOptions } from 'src/libs/react-query';
import { userKeys } from './user-keys';

export interface Balance {
  balance: number;
  token_name: string;
  min_balance_for_reward: number
}

export interface GetUserPortfolioResponse {
  [chainId: string]: Balance[];
}

export interface GetUserPortfolioParams {
  chainId: number;
}

export const getUserPortfolio = async (params?: GetUserPortfolioParams) => {
  const { data } = await apiClient.get<GetUserPortfolioResponse>(
    '/v2/users/portfolio',
    params ? { params } : undefined,
  );
  return data;
};

export type UseGetUserPortfolioOptions<TData, TError> = QueryOptions<
  GetUserPortfolioResponse,
  TError,
  TData,
  ReturnType<typeof userKeys.allUserPortfolio>
>;

export const useGetUserPortfolio = <TData = GetUserPortfolioResponse, TError = Error>(
  params?: GetUserPortfolioParams,
  options?: UseGetUserPortfolioOptions<TData, TError>,
) => {
  const { isAuthenticated, isEthereumWallet } = useAuth();
  return useQuery({
    queryKey: userKeys.allUserPortfolio(params),
    queryFn: () => getUserPortfolio(params),
    enabled: isAuthenticated && isEthereumWallet,
    ...options,
  });
};
